import type { ReactNode } from 'react';

import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '@/_components';

type InvoicesBottomSplitViewProps = {
  leftContent: ReactNode;
  rightContent: ReactNode;
};

export function InvoicesBottomSplitView({ leftContent, rightContent }: InvoicesBottomSplitViewProps) {
  return (
    <ResizablePanelGroup orientation="horizontal">
      <ResizablePanel defaultSize={56} minSize={35}>
        <div className="h-full pr-2">{leftContent}</div>
      </ResizablePanel>
      <ResizableHandle withHandle className="bg-c-border w-2 after:w-4" />
      <ResizablePanel defaultSize={44} minSize={28}>
        <div className="h-full pl-2">{rightContent}</div>
      </ResizablePanel>
    </ResizablePanelGroup>
  );
}
